import { store } from "@betacrew/jars-flux";
import { componentKey, setLoadingState, setRecipientCreationSuccess, setZipCodeValidationSuccess, setPaginationState, setPayersList, setRecipientEditSuccessfull, setRequestType, setRecipientType, setTinNotProviderState, setRecipientBasicInformation, setRecipientAddressInformation, setRecipientOptionalInformation, setRecipientBasicInformationFieldsTouched, setRecipientAddressInformationFieldsTouched, setRecipientOptionalInformationFieldsTouched, setSelectedPayer, setSelectedRecipient, setRecipientDetailId, setSubmittedRecipient, setW8W9Fees } from "./AddRecipientSlice";
import { all, put, takeLatest } from "redux-saga/effects";
import { PAGE_STATE } from "../../constants/constants";
import GeneralDataService from "../../../../services/GeneralDataService";
import { TOASTER_VARIANT } from "../../../components/toast/constants";
import { addNotifications } from "../../toaster/ToasterPortalSlice";
import RecipientDataService from "../../../../services/RecipientDataService";
import Payer from "../../../../libs/utility/Payer";
import { REQUEST_TYPE_STATUS } from "./steps/getrequesttype/constants";
import Recipient from "../../../../libs/utility/Recipient";
import { RECIPIENT_TYPE_1042_S, RECIPIENT_TYPE_TITLE } from "./getrecipienttype/constants";
import { ADD_RECIPIENT_LOADING_STATES } from "./constant";

export const { validateZipCode, addRecipient, editRecipient, getRecipientDataById, getW8W9Fees } = {
    validateZipCode: (payload) => {
        return {
            type: "RECIPIENT/VALIDATE_ZIP_CODE_NEW",
            payload
        }
    },

    addRecipient: (payload) => {
        return {
            type: "ADD_RECIPIENT_NEW",
            payload
        }
    },

    editRecipient: (payload) => {
        return {
            type: "EDIT_RECIPIENT_NEW",
            payload
        }
    },

    getRecipientDataById: (payload) => {
        return {
            type: "GET_RECIPIENT_DATA_BY_ID_NEW",
            payload
        }
    },

    getW8W9Fees: (payload) => {
        return {
            type: "ADD_RECIPIENTS/GET_W8_W9_FEES",
            payload
        }
    }
}

function* validateZipCodeAsync(action) {

    try {
        yield put(setZipCodeValidationSuccess(false));
        yield put(setLoadingState({ state: ADD_RECIPIENT_LOADING_STATES.VALIDATE_ZIP_CODE_LOADING }))

        const { RecipientCountry, RecipientState, RecipientZIP } = action.payload;

        if (RecipientCountry?.value !== "US") {
            yield put(setZipCodeValidationSuccess(true));
            yield put(setLoadingState({ state: ADD_RECIPIENT_LOADING_STATES.VALIDATE_ZIP_CODE_READY }))
            return;
        }

        const data = {
            State: RecipientState.value,
            ZipCode: RecipientZIP.value
        }

        const response = yield GeneralDataService.validateZipCode(data);

        if (response?.data?.Status) {
            yield put(setZipCodeValidationSuccess(true));
        } else {
            yield put(setZipCodeValidationSuccess(false));
            yield put(addNotifications({ heading: "Zip code validation failed", message: response?.data?.Message }));
        }


    } catch (error) {
        console.error(error)
        yield put(setZipCodeValidationSuccess(false));
        yield put(addNotifications({ heading: "Failed to validate the zip code", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state:  ADD_RECIPIENT_LOADING_STATES.VALIDATE_ZIP_CODE_READY }))
    }

}

function* addRecipientAsync(action) {

    try {

        yield put(setLoadingState({ state: ADD_RECIPIENT_LOADING_STATES.SAVE_RECIPIENT_LOADING }))

        const { RecipientType, recipientBasicInfo, recipientAddressInformation, recipientOptionalInformation, zipCodeValidationSuccess, RequestType, selectedPayer, is1042SForm = false } = action.payload;

        if (!zipCodeValidationSuccess) {
            yield put(addNotifications({
                heading: "Zip Code Not Validated",
                message: "Please validate the zip code before adding the recipient",
            }));

            yield put(setLoadingState({ state: ADD_RECIPIENT_LOADING_STATES.SAVE_RECIPIENT_READY}))
            return;
        }

        if (!selectedPayer?.PayerDetailId) {
            yield put(addNotifications({
                heading: "Payer not selected",
                message: "Please select a payer before adding a recipient",
            }));

            yield put(setLoadingState({ state: ADD_RECIPIENT_LOADING_STATES.SAVE_RECIPIENT_READY }))
            return;
        }

        const recipientData = {
            PayeeType: Recipient.getPayeeType(RecipientType, is1042SForm),
            PayeeFileType: Recipient.getPayeeFileType(RecipientType),
            PayeeTIN: Payer.removeHyphens(recipientBasicInfo.RecipientTIN.value),
            PayerID: selectedPayer?.PayerDetailId,

            PayeeFirstName: recipientBasicInfo.RecipientFirstName?.value,
            PayeeMiddleName: recipientBasicInfo.RecipientMiddleName?.value,
            PayeeLastName: recipientBasicInfo.RecipientLastName?.value,
            PayeeSuffix: recipientBasicInfo.RecipientSuffix?.value,

            PayeeEmail: recipientBasicInfo.RecipientEmail?.value,
            PayeePhNo: recipientBasicInfo.RecipientPhNo?.value,

            PayeeAddress: recipientAddressInformation?.RecipientAddress?.value,
            PayeeAddress2: recipientAddressInformation?.RecipientAddress2?.value,
            PayeeCity: recipientAddressInformation?.RecipientCity?.value,
            PayeeState: recipientAddressInformation?.RecipientState?.value,
            PayeeCountry: recipientAddressInformation?.RecipientCountry?.value,
            PayeeZIP: recipientAddressInformation?.RecipientZIP?.value,

            PayeeID: 0,
            AttentionTo: recipientOptionalInformation?.AttentionTo?.value,

            isW9Request: RequestType === 'W-9 Request' ? true : false,
            FTIN: "",
            GIIN: "",
            ClientRecipientId: recipientOptionalInformation?.Isrecipientclient?.value,
        }

        const response = yield RecipientDataService.saveRecipient(recipientData);

        const { Status, Message, Data } = response?.data;

        if (Status) {
            yield put(setSubmittedRecipient(Data))
            yield put(setRecipientCreationSuccess(true));
            yield put(addNotifications({ heading: "Recipient added successfully", message: Message, variant: TOASTER_VARIANT.SUCCESS }));
        } else {
            yield put(addNotifications({ heading: "Something went wrong, Failed to add the recipient", message: Message }));
        }

    } catch (error) {
        console.error(error)
        yield put(setRecipientCreationSuccess(false))
        yield put(addNotifications({ heading: "Failed to add the recipient", message: error?.response?.data?.Message }));
    } finally {
        const { RequestType } = action.payload;
        yield put(setLoadingState({ state: ADD_RECIPIENT_LOADING_STATES.SAVE_RECIPIENT_READY }))

        if (RequestType === REQUEST_TYPE_STATUS.W8REQUEST || RequestType === REQUEST_TYPE_STATUS.W9REQUEST) {
            yield put(getW8W9Fees())
        }

    }

}

function* editRecipientAsync(action) {

    try {

        yield put(setLoadingState({ state: ADD_RECIPIENT_LOADING_STATES.EDIT_RECIPIENT_LOADING }))

        const { RecipientType, recipientBasicInfo, recipientAddressInformation, recipientOptionalInformation, zipCodeValidationSuccess, RequestType, selectedPayer, selectedRecipient, RecipentDetailId, is1042SForm = false } = action.payload;

        if (!zipCodeValidationSuccess) {
            yield put(addNotifications({
                heading: "Zip Code Not Validated",
                message: "Please validate the zip code before adding the payer",
            }));

            yield put(setLoadingState({ state:  ADD_RECIPIENT_LOADING_STATES.EDIT_RECIPIENT_READY }))
            return;
        }

        const recipientData = {
            PayeeType: Recipient.getPayeeType(RecipientType, is1042SForm),
            PayeeFileType: Recipient.getPayeeFileType(RecipientType),

            PayeeTIN: Payer.removeHyphens(recipientBasicInfo.RecipientTIN.value),
            PayerID: selectedPayer?.PayerDetailId,

            PayeeFirstName: recipientBasicInfo.RecipientFirstName?.value,
            PayeeMiddleName: recipientBasicInfo.RecipientMiddleName?.value,
            PayeeLastName: recipientBasicInfo.RecipientLastName?.value,
            PayeeSuffix: recipientBasicInfo.RecipientSuffix?.value,

            PayeeEmail: recipientBasicInfo.RecipientEmail?.value,
            PayeePhNo: recipientBasicInfo.RecipientPhNo?.value,

            PayeeAddress: recipientAddressInformation?.RecipientAddress?.value,
            PayeeAddress2: recipientAddressInformation?.RecipientAddress2?.value,
            PayeeCity: recipientAddressInformation?.RecipientCity?.value,
            PayeeState: recipientAddressInformation?.RecipientState?.value,
            PayeeCountry: recipientAddressInformation?.RecipientCountry?.value,
            PayeeZIP: recipientAddressInformation?.RecipientZIP?.value,

            AttentionTo: recipientOptionalInformation?.AttentionTo?.value,
            PayeeID: selectedRecipient?.RecipentDetailId || RecipentDetailId,

            isW9Request: RequestType === 'W-9 Request' ? true : false,
            FTIN: "",
            GIIN: "",
            ClientRecipientId: recipientOptionalInformation?.Isrecipientclient?.value,
        }

        const response = yield RecipientDataService.editRecipient(recipientData);

        if (response.data.Status) {
            // yield put(setRecipientCreationSuccess(true))
            yield put(setRecipientEditSuccessfull(true))
            yield put(addNotifications({ heading: "Recipient Updated Successfully", variant: TOASTER_VARIANT.SUCCESS }));
        } else {
            yield put(addNotifications({ heading: "Something went wrong, Failed to update the recipient details", message: response?.data?.Message }));
        }

    } catch (error) {
        console.error("err: ", error)
        yield put(setRecipientEditSuccessfull(false))
        yield put(addNotifications({ heading: "Failed to update the recipient details", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: ADD_RECIPIENT_LOADING_STATES.EDIT_RECIPIENT_READY }))
    }
}

function* getRecipientDataByIdAsync({ payload }) {
    try {
        yield put(setLoadingState({ state: PAGE_STATE.LOADING, message: "Fetching Data" }));

        const { is1042SForm = false, RecipentDetailId, statesList, countriesList } = payload;
        const response = yield RecipientDataService.getRecipient(RecipentDetailId);

        const { Message, Status, Data } = response?.data;

        if (Status) {

            yield put(setRequestType(""))

            if (is1042SForm) {
                const recipientType = RECIPIENT_TYPE_1042_S.find(r => r.value === Data?.IdType);

                if (recipientType) {
                    yield put(setRecipientType(recipientType?.title || ""));
                }
            } else {
                yield put(setRecipientType(Data.IdType === "SSN" ? RECIPIENT_TYPE_TITLE.INDIVIDUAL : RECIPIENT_TYPE_TITLE.BUSINESS))
            }

            yield put(setTinNotProviderState(Data?.IdNumber ? false : true))

            yield put(setRecipientBasicInformation({
                RecipientFirstName: { value: Data?.FirstName || "" },
                RecipientMiddleName: { value: Data?.MiddleName || "" },
                RecipientLastName: { value: Data?.LastName || "" },
                RecipientTIN: { value: Data?.IdNumber || "" },
                RecipientEmail: { value: Data?.emailid || "" },
                RecipientPhNo: { value: Data?.Phone || "" },
                RFilerType: { value: "" },
                RecipientSuffix: { value: Data?.Suffix || "" },
            }))

            yield put(setRecipientAddressInformation({
                RecipientAddress: { value: Data?.Address1 || "" },
                RecipientAddress2: { value: Data?.Address2 || "" },
                RecipientCity: { value: Data?.City },
            }))

            yield put(setRecipientOptionalInformation({
                AttentionTo: { value: Data?.AttentionTo || "" },
                Isrecipientclient: { value: Data?.ClientRecipientId || "" },
            }))

            yield put(setRecipientDetailId(Data?.RecipentDetailId));
            yield put(setRecipientBasicInformationFieldsTouched(true))
            yield put(setRecipientAddressInformationFieldsTouched(true))
            yield put(setRecipientOptionalInformationFieldsTouched(true))
            yield put(setZipCodeValidationSuccess(true));
            yield put(setSelectedPayer({ PayerDetailId: Data?.PayerId }))
            yield put(setSelectedRecipient({ RecipentDetailId: Data?.RecipentDetailId }));


            const country = countriesList?.find(country => country?.Country_code === Data?.Country)

            let state = { label: Data?.State };
            if (Data?.Country === "US") {
                state = statesList.find(state => state.StateAbbreviation === Data?.State);
            }

            yield put(setRecipientAddressInformation({ RecipientCountry: country }))
            yield put(setRecipientAddressInformation({ RecipientState: state }))
            yield put(setRecipientAddressInformation({ RecipientZIP: { value: Data?.ZipCode || "" } }))

            if (Data?.Country === "US") {
                yield put(setZipCodeValidationSuccess(false))
            } else {
                yield put(setZipCodeValidationSuccess(true))
            }

        } else {
            yield put(addNotifications({ heading: "Failed to fetch the recipient details", message: Message }));
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Failed to fetch the recipient details", message: error?.response?.data?.Message, variant: TOASTER_VARIANT.DANGER }));
    } finally {
        yield put(setLoadingState({ state: PAGE_STATE.PAGE_READY, message: "" }));
    }
}

function* getW8W9FeesAsync(action) {

    try {
        yield put(setLoadingState({ state: PAGE_STATE.LOADING }));

        const response = yield RecipientDataService.getW8W9Fees(1);

        const { Data, Message, Status } = response?.data;

        if (Status) {
            yield put(setW8W9Fees(Data))
        } else {
            yield put(addNotifications({ heading: "Failed to get the W8 fees", message: Message }));
        }

    } catch (error) {
        console.log('err: ', error)
        yield put(addNotifications({ heading: "Failed to get the W8 fees", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: PAGE_STATE.PAGE_READY }));
    }
}

function* rootSaga() {
    yield all([
        takeLatest(validateZipCode().type, validateZipCodeAsync),
        takeLatest(addRecipient().type, addRecipientAsync),
        takeLatest(editRecipient().type, editRecipientAsync),
        takeLatest(getRecipientDataById().type, getRecipientDataByIdAsync),
        takeLatest(getW8W9Fees().type, getW8W9FeesAsync)
    ]);
}

store.sagaManager.addSaga(componentKey, rootSaga);